var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',[_c('v-img',{staticClass:"logo-img",attrs:{"src":_vm.green === 'green'
        ? _vm.logoUrl
        : _vm.logoWhiteUrl,"max-height":"40","contain":"","position":"left center","alt":"ParkingBnB"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }